module.exports = "#member-container {\n  height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/member/member.component.less
// module id = 477
// module chunks = 0